<template>
    <!--header section-->
    <div>
        <div class="header-section-web col-12 float-l" v-show="isShowLoggedinfields && isHeaderShow" > <!--Start web header section-->
            <div class="container">
                
                <div class="row">
                    
                    <div class="logo-section float-l">
                        <router-link v-bind:to="{name: 'ChatList'}" class="float-l"> <img src="/static/images/vvg-logo.png" alt="Velocity Vehicle Group"> </router-link>
                    </div>

                    <div class="header-right-section float-r">

                        <div class="form-group float-l">
                            <p class="select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"> User </p>

                            <ul class="nav navbar-nav navbar-right">
                                <li class="dropdown">
                                    <a href="javascript:void(0)" data-toggle="dropdown" aria-expanded="false" class="dropdown-toggle"><p class="mb_0">{{ loggedin_user_name }}</p> <span> <i class="fa fa-angle-down"></i> </span>
                                    </a>
                                    <ul class="dropdown-menu">
                                        <li><router-link v-bind:to="{name: 'SiteList'}">My Sites</router-link> </li>
                                        <li v-if="cantAccessPage === true"><router-link v-bind:to="{name: 'UserList'}">User List</router-link> </li>
                                        <li v-if="cantAccessPage === true"><router-link v-bind:to="{name: 'CustomerList'}">Customer List</router-link></li>
                                        <li><router-link v-bind:to="{name: 'ArchivedChat'}">Archived Chat</router-link></li>
                                        <li v-if="currentEnvironment && cantAccessPage === true"><router-link v-bind:to="{name: 'MailList'}">Mail List</router-link></li>
                                        <li v-if="cantAccessPage === true"><router-link v-bind:to="{name: 'ListSectionSchedulerTime'}">Schedule Section</router-link></li>
                                    </ul>
                                </li>
                            </ul>                           
                        </div>

                        <div class="form-group float-l">
                            <p class="select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"> Status </p>
                            
                            <div class="dropdown">

                                <ul class="nav navbar-nav navbar-right">
                                    <li class="dropdown">
                                        <a href="javascript:void(0)" data-toggle="dropdown" aria-expanded="false" class="dropdown-toggle"><p class="mb_0"> {{status}} </p> <span> <i class="fa fa-angle-down"></i> </span>
                                        </a>
                                        <ul class="dropdown-menu">
                                        <li> <a href="javascript:void(0)" v-on:click="changeStatus('online')"> Online </a> </li>
                                        <li> <a href="javascript:void(0)" v-on:click="changeStatus('offline')"> Offline </a> </li>
                                        </ul>
                                    </li>
                                </ul> 
                            </div>
                        </div>

                        <div class="logout-btn float-r">
                            <button id="logoutbtn" type="submit" class="btn btn-primary internal-large-btn" v-on:click="logout()">
                                Logout
                            </button>
                        </div>

                    </div>

                </div>
            </div>
        </div> <!--End web header section-->
        <div class="header-section header-section-mobile col-12 float-l bgcolor-cfe3ee" v-if="isShowLoggedinfields && (routePathModule != 'chat' ||  mobileHeaderText != 'Customer Detail')"> <!--header section-->
            <div class="back-btn-chat float-l">
                <!-- <a href="#"> <i class="hi-icon icon-chatback"></i> </a> -->
                <router-link v-if="mobileHeaderText == 'User Detail'" v-bind:to="{name: 'UserList'}"><i class="hi-icon icon-chatback"></i> </router-link>
                <router-link v-if="mobileHeaderText == 'User List'" v-bind:to="{name: 'ChatList'}"><i class="hi-icon icon-chatback"></i> </router-link>
                <router-link v-if="mobileHeaderText == 'Customer List'" v-bind:to="{name: 'ChatList'}"><i class="hi-icon icon-chatback"></i> </router-link>
                <router-link v-if="mobileHeaderText == 'User Create'" v-bind:to="{name: 'UserList'}"><i class="hi-icon icon-chatback"></i> </router-link>
                <router-link v-if="mobileHeaderText == 'Archived Chat'" v-bind:to="{name: 'ChatList'}"><i class="hi-icon icon-chatback"></i> </router-link>
                <router-link v-if="mobileHeaderText == 'Site List'" v-bind:to="{name: 'ChatList'}"><i class="hi-icon icon-chatback"></i> </router-link>
                <router-link v-if="currentEnvironment && mobileHeaderText == 'Mail List'" v-bind:to="{name: 'MailList'}"><i class="hi-icon icon-chatback"></i> </router-link>
            </div>

            <div class="customer-name float-l colpie-80">
                <p v-if="mobileHeaderText != 'User Create'" class="color-231f20 font-roboto-bold heading-text-16 line-height-20 agent-customer-name float-l width-full pt_10 pl_40 mb_0"> {{mobileHeaderText}}
                </p>
                <p v-else class="color-231f20 font-roboto-bold heading-text-16 line-height-20 agent-customer-name float-l width-full pt_10 pl_40 mb_0"> Add User
                </p>
            </div>

            <div class="right-header-section float-r" v-if="mobileHeaderText != 'Site List' && mobileHeaderText != 'Archived Chat'">
                <div class="search-bar-right">
                    <div class="searchbox">
                        <input type="search" v-model="searchText" placeholder="Search......" name="search" @input="searchAPI(mobileHeaderText)" class="searchbox-input" required>
                        <!-- <input type="submit" class="searchbox-submit" value=""> -->
                        <!-- {{searchOpen}} -->
                        <a v-if="!searchOpen" href="javascript:void(0)" v-on:click="searchBoxClose()" class="searchbox-icon"><img src="/static/images/search-close.png"></a>
                        <span v-if="searchOpen" class="searchbox-icon" v-on:click="searchBoxOpen()"> <i class="hi-icon icon-chatmagnifying-glass"></i> </span>
                    </div>
                </div>
            </div>

            <div class="menu-right-header float-r"> <!--header menu section-->
                <div class="nc-chat-right-dropdown">
                    <div class="dropdown">
                        <button class="more-btn btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">
                            <span class="more-dot"></span>
                            <span class="more-dot"></span>
                            <span class="more-dot"></span>
                        </button>

                        <ul class="dropdown-menu">
                            <p class="user-name color-f5911e heading-text-14 line-height-20 font-benton-bold float-l width-full">
                                <span v-if="status == 'Online' || status == 'online'" class="bgcolor-5cbb55 p_5 pull-left absolute l-15 t-5 radius-100"></span>
                                <span v-else class="bgcolor-ff3636 p_5 pull-left absolute l-15 t-5 radius-100"></span>
                                {{loggedin_user_name}}
                                
                            </p>
                            <li> <router-link v-bind:to="{name: 'SiteList'}">My Sites <span> <i class="fa fa-angle-right custom" ></i> </span> </router-link> </li>
                            <li v-if="cantAccessPage === true"> <router-link v-bind:to="{name: 'UserList'}"> User List <span> <i class="fa fa-angle-right custom" ></i> </span> </router-link> </li>
                            <li v-if="cantAccessPage === true"> <router-link v-bind:to="{name: 'CustomerList'}"> Customer List <span> <i class="fa fa-angle-right custom" ></i> </span> </router-link> </li>
                            <li v-if="cantAccessPage === true"> <router-link v-bind:to="{name: 'ArchivedChat'}"> Archived Chat <span> <i class="fa fa-angle-right custom" ></i> </span> </router-link> </li>
                            <li v-if="currentEnvironment && cantAccessPage === true"> <router-link v-bind:to="{name: 'MailList'}"> Mail List <span> <i class="fa fa-angle-right custom" ></i> </span> </router-link> </li>
                            <li class="user-status-edit" v-if="(status == 'Online' || status == 'online') && routePathModuleDetail != 'detail'">
                                <a href="javascript:void(0)" v-on:click="changeStatus('offline')"> Offline
                                    <span>
                                        <i class="fa fa-angle-right custom"></i>
                                    </span>
                                </a>
                            </li>
                            <li class="user-status-edit" v-if="(status == 'offline' || status == 'Offline') && routePathModuleDetail != 'detail'">
                                <a href="javascript:void(0)" v-on:click="changeStatus('online')"> Online
                                    <span>
                                        <i class="fa fa-angle-right custom"></i>
                                    </span>
                                </a>
                            </li>
                            <li> <a v-on:click="logout()" href="javascript:void(0)"> Sign Out <span> <i class="fa fa-angle-right custom" ></i> </span> </a> </li>
                        </ul>
                    </div>
                </div>
            </div> <!--header menu section-->
        </div> <!--header section-->
    </div>
</template>

<script>

    import Vue from 'vue';
    import EventBus from '.././event-bus';
    var contex;
    import {HTTP} from '../../http-common.js';
    import {commonMixins} from '../../mixins/commonMixins';

    export default {
        name: "Header",
        mixins: [commonMixins],
        data: () => ({
            cantAccessPage: true,
            isRequestComplete: false,
            logoutFailFlag: false,
            isShowLoggedinfields: false,
            loggedin_user_name:'',
            username:"",
            status: '',
            routePathModule: '',
            logingId: 0,
            mobileHeaderText: '',
            isHeaderShow: true,
            role: '',
            searchText: '',
            searchOpen: true,
            channel: null
        }),
        beforeMount: function () {
            contex = this;
        },
        mounted: function () {
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            self.routePathModule = segments[1] == 'chat' ? segments[1] : self.ucString(segments[1]);
            self.routePathModuleDetail = segments[2];

            if(localStorage.getItem("status") && localStorage.getItem("status") != null) {
                self.status = self.ucString(localStorage.getItem("status"));
            }

            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
                self.logingId = userJson["id"];
                self.userName = userJson['name'];
            }
            // self.getPermissions();
        },
        created() {
            var self = this;
            self.channel = self.$pusher.subscribe('private-chat');
            self.channel.bind('client-status-event', function(data) {
                // alert(data);    
            });

            /* self.channel.bind('pusher:subscription_succeeded', function() {
                console.log("Success");
                console.log(self.channel);
            });

            self.channel.bind('pusher:subscription_error', function(status) {
                console.log("error" + status);
            }); */
        },
        methods: {
            searchBoxOpen: function() {
                var self = this;
                var submitIcon = $('.searchbox-icon');
                var inputBox = $('.searchbox-input');
                var searchBox = $('.searchbox');
                var isOpen = false;
                // submitIcon.click(function(){
                    if(isOpen == false){
                        searchBox.addClass('searchbox-open');
                        inputBox.focus();
                        isOpen = true;
                        self.searchOpen = false;
                    } else {
                        searchBox.removeClass('searchbox-open');
                        inputBox.focusout();
                        isOpen = false;
                        self.searchOpen = true;
                    }
                // });  
                submitIcon.mouseup(function(){
                    return false;
                });
                searchBox.mouseup(function(){
                    return false;
                });
                /* $(document).mouseup(function(){
                    if(isOpen == true){
                        $('.searchbox-icon').css('display','block');
                        submitIcon.click();
                        self.searchOpen = true;
                    }
                }); */
            },
            searchBoxClose: function() {
                var self = this;
                var inputBox = $('.searchbox-input');
                var searchBox = $('.searchbox');
                searchBox.removeClass('searchbox-open');
                inputBox.focusout();
                self.searchOpen = true;
            },
            searchAPI: function(value) {
                // alert(value);

                var self = this;
                var valueSerach = value.split(" ");

                var serachURL = (valueSerach[0].toLowerCase() == 'user') ? 'list-user' : 'interacted-customers'

                var fields = {
                    isUserList: (serachURL == 'list-user') ? 'chatUser' : 'chatCustomer',
                    isCustomerList : 'chatCustomer',
                    searchFlag: valueSerach[0].toLowerCase(),
                    searchText: self.searchText,
                };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                //self.showLoader();
                HTTP.post(serachURL, fields, config)
                        .then(function (response) {
                            if (response.data.code == '200') {

                                if(valueSerach[0].toLowerCase() == 'user') {
                                    // self.userArray = response.data.content;
                                    EventBus.$emit("serachUserArrayData", response.data.content);
                                } else {
                                    // self.customerArray = response.data.content;
                                    EventBus.$emit("serachCustomerArrayData", response.data.content);
                                }
                            }
                            //self.hideLoader();
                        })
                        .catch(function (error) {
                            //self.hideLoader();
                            self.catchHandler(error, function () {});
                        });
            },
            logout: function() {
                var self = this;
                //clear all local storage
                self.$swal({
                    title: '',
                    text: 'Really wants to logout?',
                    type: 'question',
                    confirmButtonText: 'OK',
                    showCancelButton: true,
                    // showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        $('#logoutbtn').text("Logout...");
                        $("#logoutbtn").attr("disable", true);
                        var fields = {
                            apiToken: localStorage.getItem("tkn"),
                            logoutFlag: self.logoutFailFlag
                        };

                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                        };
                        //self.showLoader();
                        HTTP.post("signout", fields, config)
                            .then(function (response) {
                                if (response.data.code == '200') {
                                    localStorage.clear();
                                    window.location.href = "/";
                                    setTimeout(function () {
                                        $('#logoutbtn').text("Logout");
                                        $("#logoutbtn").attr("disable", false);
                                    }, 100);
                                } else if (response.data.code == '203') {
                                    localStorage.clear();
                                    window.location.href = "/";
                                }
                                //self.hideLoader();
                            })
                            .catch(function (err) {
                                //self.hideLoader();
                                //self.showSAlert("Please Try again Later!", 'error');
                                $('#logoutbtn').text("Logout");
                                $("#logoutbtn").attr("disable", false);
                                self.$swal({
                                    title: 'Error',
                                    text: 'Please Try again Later!',
                                    type: 'error',
                                    confirmButtonText: 'Retry',
                                    //showCloseButton: true,
                                    showLoaderOnConfirm: true
                                }).then((result) => {
                                    if (result.value) {
                                        /* localStorage.clear();
                                        window.location.href = "/"; */
                                        self.logoutFailFlag = true;
                                        self.logout();
                                    }
                                });
                                //self.catchHandler(err, function () {});
                            });
                    }
                });
                
            },
            changeStatus(changeStatusValue) {

                var self = this;
                /* localStorage.setItem("status", self.ucString(changeStatusValue));
                EventBus.$emit("changeStatus", changeStatusValue);
                self.status = self.ucString(changeStatusValue); */
                
                var fields = {
                    user_status: changeStatusValue,
                    user_id: self.logingId
                };

                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };

                HTTP.post("change-user-status", fields, config)
                    .then(function (response) {
                        if (response.data.code == '200') {

                            if(changeStatusValue == 'Online' || changeStatusValue == 'online') {
                                self.triggerStatus('client-status-event', self.logingId, "online");
                            } else {
                                self.triggerStatus('client-status-event', self.logingId, "offline");
                            }
                            //self.loadUser();
                            localStorage.setItem("status", self.ucString(changeStatusValue));
                            self.status = self.ucString(changeStatusValue);
                            self.$swal({
                                title: 'Success',
                                text: "Change Status Successfully ",
                                type: 'success',
                                confirmButtonText: 'Ok',
                                showLoaderOnConfirm: true
                            })
                        }
                    })
                    .catch(function (err) {
                        console.log(err);
                        self.catchHandler(err, function () {});
                    });
                
            },
            triggerStatus(eventName, message, status) {
                var self = this;
                var statusMessageArray = {
                    "message": message,
                    "status": status
                };
                self.channel.trigger(eventName, statusMessageArray);
            },
        },

    };

    EventBus.$on('logged-in', function (isLogin, name, email, id, role) {

        contex.isShowLoggedinfields = isLogin;
        contex.loggedin_user_name = name;
        contex.username = email;
        contex.role = role;
        var roleData = role.split(" ");
        if(roleData[1] && roleData[1] != '') {
            contex.role = roleData[1];
        }

    });

    EventBus.$on("logoutMobileSide", function(data) {
        contex.logout();
    });

    EventBus.$on("changeStatus", function(data) {
        contex.changeStatus(data);
    });
    EventBus.$on("headerMobileView", function(data) {
        if( data == 'Customer Detail' || data == 'User Detail') {
            contex.isHeaderShow = false;
        } else {
            contex.isHeaderShow = true;
        }
        contex.mobileHeaderText = data;
        contex.getPermissions();
        contex.searchText = "";
    });

</script>


// WEBPACK FOOTER //
// src/components/partials/Header.vue